import flatpickr from "flatpickr";
import { Polish } from "flatpickr/dist/l10n/pl";
import Glide from "@glidejs/glide";

export default {
	init() {

		/* Dostosowanie wysokości na iOS */

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		window.addEventListener("resize", () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		});


		const body = document.querySelector(".body");
		body.classList.add("body--loaded");

		const setClassNav = () => {
			if (body.classList.contains("body--dark")) {
				navBar.classList.add("nav-bar--light");
				menuLogo.children[1].classList.add("nav-bar__logo--active");
				menuLinks.forEach((link) => {
					link.classList.add("nav-bar__link--invert");
				});
			}

			if (body.classList.contains("body--light")) {
				navBar.classList.add("nav-bar--dark");
				menuLogo.children[0].classList.add("nav-bar__logo--active");
			}
		};

		/* Przejście do rezerwacji */

		const reservation = document.querySelector("#reservation");
		const englishParameter = window.location.search;
		let reservationOffsetScroll = 0;
		if(window.innerWidth < 560) {
			reservationOffsetScroll = 60;
		}

		const scrollTo = (element, offset) => {
			window.scroll({
				behavior: "smooth",
				left: 0,
				top: element.offsetTop - offset
			});
		}

		function redirectToHomepageAndScrollToReservation() {
			if(englishParameter) {
				window.location.href = window.location.origin + '/' + window.location.search + "#reservation";
			} else {
				window.location.href = window.location.origin + '/#reservation';
			}
		}

		/* Nawigacja */

		const navBar = document.querySelector(".nav-bar");
		const menuLogo = document.querySelector(".nav-bar__home");
		const menuLinks = document.querySelectorAll(".nav-bar__link");
		const menuItems = document.querySelectorAll(".menu__link");
		const menuBtn = document.querySelector(".nav-bar__btn--menu");
		const fullpageMenu = document.querySelector(".menu");
		menuItems[5].classList.add('virtual-tour-link');
		menuItems[6].classList.add('reservation-link');
		menuItems[7].setAttribute("target", "_blank");

		const linkToForm = document.querySelector('.reservation-link');
		linkToForm.addEventListener('click', (e) => {
			e.preventDefault();
			closeMenu();
			if(reservation) {
				scrollTo(reservation, reservationOffsetScroll);
			} else {
				redirectToHomepageAndScrollToReservation();
			}
		});

		window.onscroll = () => {
			if (window.scrollY >= 100) {
				navBar.classList.add("nav-bar--fixed");
				if (body.classList.contains("body--light")) {
					menuLogo.children[0].classList.remove("nav-bar__logo--active");
					menuLogo.children[1].classList.add("nav-bar__logo--active");
				}
				menuLinks.forEach((link) => {
					link.classList.add("nav-bar__link--invert");
				});
			} else {
				navBar.classList.remove("nav-bar--fixed");
				if (body.classList.contains("body--light")) {
					menuLogo.children[0].classList.add("nav-bar__logo--active");
					menuLogo.children[1].classList.remove("nav-bar__logo--active");
					menuLinks.forEach((link) => {
						link.classList.remove("nav-bar__link--invert");
					});
				}
			}
		};

		menuBtn.addEventListener("click", (e) => {
			e.currentTarget.parentElement.classList.toggle("nav-bar__elements--hidden");
			menuLogo.classList.toggle("nav-bar__home--hidden");
			menuBtn.firstElementChild.classList.toggle("nav-bar__bar--animate");
			fullpageMenu.classList.toggle("menu--is-open");
		});

		function closeMenu() {
			menuBtn.parentElement.classList.remove("nav-bar__elements--hidden");
			menuLogo.classList.remove("nav-bar__home--hidden");
			menuBtn.firstElementChild.classList.remove("nav-bar__bar--animate");
			fullpageMenu.classList.remove("menu--is-open");
		}

		setClassNav();

		/* Scroll */

		const btnReservation = document.querySelector(".nav-bar__btn--reservation");

		btnReservation.addEventListener("click", (e) => {
			e.preventDefault();
			closeMenu();
			if (reservation) {
				scrollTo(reservation, reservationOffsetScroll);
			} else {
				redirectToHomepageAndScrollToReservation();
			}
		});

		/* Nadanie klasy aktywnego językowi */

		const langs = document.querySelectorAll(".menu__lang");

		if (document.documentElement.lang === "pl-PL") {
			langs[1].classList.add("menu__lang--active");
		} else if (document.documentElement.lang === "en-US") {
			langs[0].classList.add("menu__lang--active");
		}

		/* Formularz rezerwacyjny */

		// if (document.querySelector(".form")) {
		//
		// 	const date = new Date();
		// 	let currentDate = date.toLocaleDateString("pl", {year: "numeric", day: "2-digit", month: "2-digit"});
		// 	let days;
		// 	let day;
		// 	let currentDay;
		// 	let closed;
		//
		// 	const calendar = flatpickr(".form__box--calendar", {
		// 		disableMobile: true,
		// 		locale: document.documentElement.lang === "pl-PL" ? Polish : null,
		// 		dateFormat: "d.m.Y",
		// 		minDate: "today",
		// 		onReady: function () {
		// 			document.querySelector(".form__title--day").textContent = currentDate;
		// 		},
		// 		onClose: function (selectedDates, dateStr) {
		//
		// 			days = this.l10n.weekdays.longhand;
		// 			day = selectedDates[0].getDay();
		// 			currentDay = days[day];
		//
		// 			if (document.documentElement.lang === "pl-PL") {
		// 				switch (currentDay) {
		// 					case "Poniedziałek":
		// 					case "Wtorek":
		// 					case "Środa":
		// 					case "Czwartek":
		// 					case "Niedziela":
		// 						closed = "20:00";
		// 						break;
		// 					case "Piątek":
		// 					case "Sobota":
		// 						closed = "23:00";
		// 						break;
		// 				}
		// 			} else {
		// 				switch (currentDay) {
		// 					case "Monday":
		// 					case "Tuesday":
		// 					case "Wednesday":
		// 					case "Thursday":
		// 					case "Sunday":
		// 						closed = "20:00";
		// 						break;
		// 					case "Friday":
		// 					case "Saturday":
		// 						closed = "23:00";
		// 						break;
		// 				}
		// 			}
		//
		// 			document.querySelector(".form__title--day").textContent = dateStr;
		//
		// 		}
		// 	});
		//
		// 	const hours = flatpickr(".form__box--hours", {
		// 		disableMobile: true,
		// 		locale: document.documentElement.lang === "pl-PL" ? Polish : null,
		// 		enableTime: true,
		// 		noCalendar: true,
		// 		dateFormat: "H:i",
		// 		defaultHour: new Date().getHours(),
		// 		defaultMinute: new Date().getMinutes(),
		// 		time_24hr: true,
		// 		minTime: "13:00",
		// 		minuteIncrement: "15",
		// 		onReady: function () {
		// 			document.querySelector(".form__title--hour").textContent = `${this.config.defaultHour}:${("0" + this.config.defaultMinute).substr(-2)}`;
		// 		},
		// 		onClose: function (selectedDates, dateStr) {
		// 			document.querySelector(".form__title--hour").textContent = dateStr;
		// 		}
		// 	});
		//
		// 	const setHoursRange = () => {
		// 		hours.config.maxTime = day === 5 || day === 6 ? closed : closed
		// 	}
		//
		// 	hours.element.addEventListener("click", setHoursRange);
		// 	hours.element.addEventListener("mouseenter", setHoursRange);
		// 	hours.element.addEventListener("touchstart", setHoursRange);
		//
		// 	const persons = flatpickr(".form__box--persons", {
		// 		disableMobile: true,
		// 		locale: Polish,
		// 		enableTime: true,
		// 		noCalendar: true,
		// 		dateFormat: "H",
		// 		defaultDate: "01",
		// 		minTime: "1",
		// 		maxTime: "20",
		// 		onReady: function() {
		// 			const input = this.calendarContainer.children[0].children[0].children[0];
		//
		// 			input.setAttribute("min", 1);
		// 			input.setAttribute("max", 20);
		// 			input.setAttribute("required", true);
		// 		},
		// 		onOpen: function() {
		//
		// 			const input = this.calendarContainer.children[0].children[0].children[0];
		//
		// 			input.addEventListener("input", (e) => {
		// 				if (e.currentTarget.value > 20) {
		// 					document.querySelector(".form__title--persons").textContent = 20;
		// 				} else {
		// 					document.querySelector(".form__title--persons").textContent = e.currentTarget.value;
		// 				}
		// 			});
		//
		// 			this.calendarContainer.children[0].children[1].style.display = "none";
		// 			this.calendarContainer.children[0].children[2].style.display = "none";
		// 			this.calendarContainer.children[0].children[0].children[1].style.display = "none";
		// 			this.calendarContainer.children[0].children[0].children[2].style.display = "none";
		// 		}
		// 	});
		//
		// 	const reservationForm = document.querySelector(".form");
		// 	const formElements = reservationForm.querySelectorAll([".form__element--input", ".form__element--textarea"]);
		//
		// 	formElements.forEach((element) => {
		//
		// 		const formElement = element.lastElementChild;
		//
		// 		formElement.addEventListener("focus", (e) => {
		//
		// 			e.currentTarget.parentElement.classList.add("form__element--active");
		//
		// 			if (e.currentTarget.value === "") {
		// 				e.currentTarget.previousElementSibling.classList.add("form__label--active");
		// 			}
		// 		});
		//
		// 		formElement.addEventListener("blur", (e) => {
		//
		// 			e.currentTarget.parentElement.classList.remove("form__element--active");
		//
		// 			if (e.currentTarget.value === "") {
		// 				e.currentTarget.previousElementSibling.classList.remove("form__label--active");
		// 			} else {
		// 				e.currentTarget.parentElement.classList.add("form__element--active");
		// 			}
		// 		});
		// 	});

			/* Wysyłka formularza */

		// 	const form = document.querySelector("form");
		// 	const formMessage = form.querySelector(".form__message");
		// 	const formErrors = form.querySelector(".form__errors");
		// 	const labels = form.querySelectorAll(".form__label");
		// 	const inputs = Array.prototype.slice.call(form.querySelectorAll(".form__input"));
		// 	const checkbox = form.querySelector(".form__checkbox")
		// 	const textarea = form.querySelector(".form__textarea");
		//
		// 	const resetValues = () => {
		// 		inputs.forEach((input) => {
		// 			input.value = "";
		// 		});
		// 		checkbox.checked = false;
		// 		textarea.value = "";
		// 	};
		//
		// 	form.addEventListener("submit", (e) => {
		// 		e.preventDefault();
		//
		// 		const object = {
		// 			"date": form.querySelector(".form__title--day").textContent,
		// 			"hours": form.querySelector(".form__title--hour").textContent,
		// 			"persons": form.querySelector(".form__title--persons").textContent,
		// 			"name": form.querySelector("#name").value,
		// 			"phone": form.querySelector("#phone").value,
		// 			"email": form.querySelector("#email").value,
		// 			"description": form.querySelector("#textarea").value,
		// 			"rodo": form.querySelector("#rodo").checked ? form.querySelector("#rodo").nextElementSibling.textContent : null,
		// 			"source": window.location.href
		// 		};
		//
		// 		const body = JSON.stringify(object);
		// 		const API_URL = `${window.location.origin}/wp-json/get/v1/send-form`;
		//
		// 		fetch(`${API_URL}`, {
		// 			method: "post",
		// 			body: body,
		// 			mode: "cors",
		// 			headers: {
		// 				"Accept": "application/json",
		// 				"Content-Type": "application/json",
		// 				},
		// 			})
		// 			.then((response) => {
		// 				if (response.ok) {
		// 					formMessage.classList.add("form__message--visible");
		//
		// 					setTimeout(() => {
		// 						formMessage.classList.remove("form__message--visible");
		// 						labels.forEach((label) => {
		// 							label.classList.remove("form__label--active");
		// 						});
		// 						resetValues();
		// 					}, 3000);
		// 				} else {
		// 					response.json().then(errors => {
		// 						errors.violations.forEach((error) => {
		// 							formErrors.classList.add("form__message--visible");
		// 							let errorItem = document.createElement("li");
		// 							errorItem.classList.add("form__error");
		// 							errorItem.textContent = error.message;
		// 							formErrors.appendChild(errorItem);
		// 						})
		// 					});
		// 				}
		// 			});
		//
		// 		formErrors.innerHTML = "";
		//
		// 	});
		// }

		/* Polityka prywatności */

		const listHeaders = document.querySelectorAll('.list__item--header');
		listHeaders.forEach(item => {
			item.addEventListener('click', e => {
				e.currentTarget.classList.toggle('expanded');
				item.childNodes[1].classList.toggle('visible')
			})
		});

		/* Slidery na mobilnych */

		if (window.innerWidth <= 600 && document.querySelector('.images')) {
			let index = 1;
			let images = document.querySelector('.images');
			if (document.querySelector('.images__wrapper--desktop')) {
				document.querySelector('.images__wrapper--desktop').remove();
			}
			images.classList.add('glide__slides');
			images.classList.remove('images');
			images.classList.remove('images--mosaic');
			images.childNodes.forEach(child => {
				if (child.nodeName !== '#text') {
					if (index === 1) {
						child.classList.add('glide__slide--active');
						index += 1;
					}
					child.classList.add('glide__slide');
					child.classList.remove('images__wrapper');
					child.classList.remove('images__wrapper--normal');
					child.classList.remove('images__wrapper--wide');
					child.childNodes[1].classList.add('glide__image');
					child.childNodes[1].classList.remove('images__item');
				}
			});

			let glide = new Glide('.glide--mobile', {
				type: 'carousel',
				startAt: 0,
				perView: 1.5,
				gap: 0,
			}).mount();
		}

		/* Wideo */

		const videoContainer = document.querySelector(".video");
		const videoFullSize = document.querySelector(".video__full");
		const videoContent = document.querySelector(".video__content");
		const videoBtnPlay = document.querySelector(".video__btn");
		const videoBtnClose = document.querySelector(".video__close");

		const movieHandler = (e) => {
			console.log(e.currentTarget);

			body.classList.toggle("body--overlay");
			videoBtnClose.classList.toggle("video__close--hidden");
			videoFullSize.classList.toggle("video__full--is-open");
			videoContent.play();

			if (videoBtnClose.classList.contains("video__close--hidden")) {
				videoContent.pause();
				videoContent.currentTime = 0;
				videoContent.load();
				videoBtnClose.classList.add("video__close--hidden");
			}
		};

		if (videoContainer) {
			videoBtnPlay.addEventListener("click", movieHandler);
			videoBtnClose.addEventListener("click", movieHandler);
		}

		/* Wirtualny spacer */

		const virtualTourLinks = document.querySelectorAll(".virtual-tour-link");
		const navBarElements = document.querySelector(".nav-bar__elements");
		const virtualTour = document.querySelector(".virtual-tour");
		const closeVirtualTour = document.querySelector(".virtual-tour-btn");

		virtualTourLinks.forEach( virtualTourLink => {
			virtualTourLink.addEventListener("click", (e) => {
				e.preventDefault();

				closeMenu();
				navBarElements.classList.add('nav-bar__elements--hide');
				virtualTour.setAttribute("src", "https://google.com/maps/embed?pb=!4v1593774903966!6m8!1m7!1sCAoSK0FGMVFpcFBnTU1pd1Vjc0ZFcUJGSEYxOTQ1elRXSDFsMHZ0Q2hyMjg5Zk0.!2m2!1d51.24420060798717!2d22.56737109174749!3f13.04!4f-7.459999999999994!5f0.4000000000000002");
				setTimeout(() => {
					closeVirtualTour.classList.add('virtual-tour-btn--active');
					virtualTour.classList.add("virtual-tour--is-open");
				}, 500);
			});
		});

		closeVirtualTour.addEventListener('click', (e) => {
			e.currentTarget.classList.remove('virtual-tour-btn--active');
			virtualTour.classList.remove("virtual-tour--is-open");
			setTimeout(() => {
				navBarElements.classList.remove('nav-bar__elements--hide');
			}, 500);
		});
	},
	finalize() {

	},
};
